import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const mixpanel = defineConnector({
  identifier: "mixpanel",
  name: "Mixpanel",
  tagLine: "Product analytics platform",
  keywords:
    "analytics events funnels retention cohorts insights flows tracking",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () =>
    "https://(?:[^/]*\\.mixpanel\\.com/.*|mixpanel\\.com/api/.*)",
  auth: (app) =>
    basicAuth({
      username: app.secret.username,
      password: app.secret.secret,
    }),
  steps: [
    {
      title: "Get your service account credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In your Mixpanel project, navigate to **Project Settings > Service Accounts** and create a new service account. Copy the username and secret.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Service account username",
          required: true,
          target: { kind: "secrets", field: "username" },
          helperText: "The service account username from Mixpanel",
        },
        {
          kind: "input",
          label: "Service account secret",
          required: true,
          target: { kind: "secrets", field: "secret" },
          helperText: "The service account secret from Mixpanel",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://mixpanel.com/api/app/me",
  },
});
